import React from "react";

const WelcomeLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <>{children}</>;
};

export default WelcomeLayout;
